// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LpvgK{display:flex;flex-direction:column;height:100%;min-height:100%}.LpvgK>:nth-child(2){flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "LpvgK"
};
module.exports = ___CSS_LOADER_EXPORT___;
